import {ProcessesFeature, RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import licenses from 'user/Licenses';
import isModelTypeEnabledForListing from 'util/isModelTypeEnabledForListing';

import {MyWorkCategory} from './my-work/MyWorkConstants';

/** Matches {@link HomeSidepanel} review-summary fetch and section visibility. */
export function hasReviewsLicense(): boolean {
  return licenses.hasLicense('LICENSE_REVIEWS');
}

/** Matches {@link HomeSidepanel} assigned process task summary visibility. */
export function shouldShowAssignedProcessTasks(): boolean {
  return (
    isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EDIT}) &&
    isModelTypeEnabledForListing(ModelTypeConstants.PROCESS_TASK)
  );
}

/** Matches {@link HomeSidepanel} recent activity section visibility. */
export function shouldShowActivitySection(): boolean {
  return BenchlingConfig.ENABLE_ACTIVITY_CENTER;
}

/** Matches {@link HomeSidepanel} recent worklists listing visibility. */
export function shouldShowWorklistsSection(): boolean {
  return (
    BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS &&
    isFeatureEnabled({feature: RegistryFeature.REGISTRY_WORKLISTS})
  );
}

export function getEnabledMyWorkCategories(): Array<MyWorkCategory> {
  const categories: Array<MyWorkCategory> = [];
  if (hasReviewsLicense()) {
    categories.push(MyWorkCategory.ENTRIES, MyWorkCategory.WORKSHEETS);
  }
  if (shouldShowAssignedProcessTasks()) {
    categories.push(MyWorkCategory.TASKS);
  }
  return categories;
}
